import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import am from './locales/am.json';
import ru from './locales/ru.json';
import en from './locales/en.json';
import { getInitialI18nLanguage, persistPublicLocale } from './utils/locale';

const initialLanguage = getInitialI18nLanguage();

persistPublicLocale(initialLanguage);

i18n
  .use(initReactI18next)
  .init({
    resources: {
      am: {
        translation: am,
      },

      ru: {
        translation: ru,
      },

      en: {
        translation: en,
      },
    },

    lng: initialLanguage,

    fallbackLng: 'am',

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
